import "./CardContainer.css";
import Card from "./card";
import { cardData } from "../componentData/CardData";
import Modal, { ModalGlass } from "../modal";

const cardDataArray = cardData;

export default function CardContainer() {
  return (
    <div className="multiple-card-container">
      {cardDataArray.map((item, index) => {
        return item.title !== "Safety Form" ? (
          <label htmlFor={item.title}>
            <Card
              title={item.title}
              image={item.image}
              description={item.description}
              index={index}
            ></Card>
            <ModalGlass modalId={item.title} style={{ Position: "absolute" }}>
              <h2 className="font-bold text-2xl">{item.title}</h2>
              <p className="p">{item.description}</p>
            </ModalGlass>
          </label>
        ) : (
          <label htmlFor={item.title}>
            <Card
              title={item.title}
              image={item.image}
              description={item.description}
              index={index}
            ></Card>
            <ModalGlass modalId={item.title} style={{ Position: "absolute" }}>
              <h2 className="font-bold text-2xl">{item.title}</h2>
              <a
                href="https://responsibility.igem.org/safety-forms/project-safety?team-id=4260"
                className="safetyLink"
              >
                See our Safety Forms
              </a>
              <a
                href="http://parts.igem.org/wiki/images/e/ed/T--TecCEM--LabSafety.pdf" 
                className="safetyLink underline text-blue-300"
              >
                Open Safety and Laboratory to know more about our measurements in lab!
              </a>
            </ModalGlass>
          </label>
        );
      })}
    </div>
  );
}
